import React from 'react'

function Downvote({ size, color, fill, strokeWidth }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M17 13.0004L13 22.0004C12.2044 22.0004 11.4413 21.6843 10.8787 21.1217C10.3161 20.5591 10 19.796 10 19.0004V15.0004H4.34003C4.05012 15.0036 3.76297 14.9439 3.49846 14.8251C3.23395 14.7064 2.99842 14.5316 2.80817 14.3128C2.61793 14.0941 2.47753 13.8365 2.39669 13.5581C2.31586 13.2797 2.29652 12.987 2.34003 12.7004L3.72003 3.70036C3.79235 3.22346 4.0346 2.78875 4.40212 2.47636C4.76965 2.16396 5.2377 1.99491 5.72003 2.00036H17M17 13.0004V2.00036M17 13.0004H19.67C20.236 13.0104 20.7859 12.8122 21.2154 12.4435C21.645 12.0749 21.9242 11.5613 22 11.0004V4.00036C21.9242 3.43942 21.645 2.92586 21.2154 2.55718C20.7859 2.1885 20.236 1.99035 19.67 2.00036H17" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}

export default Downvote